import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CompanyStatementDTO } from 'src/app/core/models/system/statement/company-statement.dto';
import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, msSize, StorageValues } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { StatementScope } from 'src/app/core/enums';
import { StorageService } from 'src/app/core/services/utelize/general/storage-service';

export interface StatementVersionSelection {
  scope           : StatementScope;
  statementIdEncSS: string | undefined;
  versionNo       : number | undefined;
}

@Component({
  selector: 'app-statement-menu-modal-form',
  templateUrl: './statement-menu-modal-form.component.html',
  styleUrls: ['./statement-menu-modal-form.component.scss']
})

export class StatementMenuModalFormComponent implements OnInit {

  @Output() downloadCsvSelected    : EventEmitter<StatementScope           >=new EventEmitter<StatementScope           >();
  @Output() downloadPdfSelected    : EventEmitter<StatementScope           >=new EventEmitter<StatementScope           >();
  @Output() generateAndViewSelected: EventEmitter<StatementScope           >=new EventEmitter<StatementScope           >();
  @Output() generateSelected       : EventEmitter<StatementScope           >=new EventEmitter<StatementScope           >();
  @Output() menuCancelled          : EventEmitter<void                     >=new EventEmitter<void                     >();
  @Output() versionSelected        : EventEmitter<StatementVersionSelection>=new EventEmitter<StatementVersionSelection>();
  @Output() viewSelected           : EventEmitter<StatementScope           >=new EventEmitter<StatementScope           >();

  @ViewChild('statementMenuModalForm', { static: false }) statementMenuModalForm!: TemplateRef<void>;

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }

  private statementMenuModalFormRef: NgbModalRef | undefined;

  public canGenerate       : boolean=false;
  public canViewCompanyOnly: boolean=false;
  public canViewHierarchy  : boolean=false;
  public companyName       : string ="";
  public generatingScope   : StatementScope | undefined;
  public isReseller        : boolean=false;
  public keepMenuOpen      : boolean=false;
  public periodText        : string ="";
  public selectedVersions  : Map<StatementScope, string>=new Map<StatementScope, string>();
  public scopeCompanyOnly  : StatementScope=StatementScope.CompanyOnly;
  public scopeHierarchy    : StatementScope=StatementScope.Hierarchy;
  public versionsByScope   : Map<StatementScope, CompanyStatementDTO[]>=new Map<StatementScope, CompanyStatementDTO[]>();

  constructor(
    private authService        : AuthenticationService,
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    private modalService       : NgbModal,
    private storageService     : StorageService
  ) { }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Keep menu open

  private get keepMenuOpenStorageKey(): string {
    try {
      return `${StorageValues.sureSimStatementMenuKeepOpen_}${this.authService?.currentUserObject()?.userId ?? -1}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return `${StorageValues.sureSimStatementMenuKeepOpen_}-1`;
    }
  }

  private loadKeepMenuOpen(): void {
    try {
      this.keepMenuOpen=this.storageService.getItem(this.keepMenuOpenStorageKey)=="true";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      this.keepMenuOpen=false;
    }
  }

  private saveKeepMenuOpen(): void {
    try {
      this.storageService.setItem(this.keepMenuOpenStorageKey, this.keepMenuOpen ? "true" : "false");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public keepMenuOpenOnChange(checked: boolean): void {
    try {
      this.keepMenuOpen=checked;
      this.saveKeepMenuOpen();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public closeForm(): void {
    try {
      this.generatingScope=undefined;
      this.statementMenuModalFormRef?.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeFormUnlessKeptOpen(): void {
    try {
      if (this.keepMenuOpen) {
        this.generatingScope=undefined;
        return;
      }

      this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(companyName       : string,
                  periodText        : string,
                  canGenerate       : boolean,
                  canViewCompanyOnly: boolean,
                  isReseller        : boolean=false,
                  canViewHierarchy  : boolean=false): void {
    try {
      this.canGenerate       =canGenerate;
      this.canViewCompanyOnly=canViewCompanyOnly;
      this.canViewHierarchy  =isReseller && canViewHierarchy;
      this.companyName       =companyName ?? "";
      this.generatingScope   =undefined;
      this.isReseller        =isReseller;
      this.periodText        =periodText  ?? "";
      this.selectedVersions  =new Map<StatementScope, string>();
      this.versionsByScope   =new Map<StatementScope, CompanyStatementDTO[]>();

      this.loadKeepMenuOpen();

      this.statementMenuModalFormRef=this.modalService.open(this.statementMenuModalForm, { backdrop     : this.modalBackGround,
                                                                                           backdropClass: 'popup-on-top-backdrop',
                                                                                           centered     : true,
                                                                                           container    : 'body',
                                                                                           keyboard     : false,
                                                                                           size         : msSize.Medium,
                                                                                           windowClass  : 'popup-on-top statement-menu-modal' });
    }
    catch(e) {
      this.menuCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setScopeAvailability(canViewCompanyOnly: boolean, canViewHierarchy: boolean): void {
    try {
      this.canViewCompanyOnly=canViewCompanyOnly;
      this.canViewHierarchy  =this.isReseller && canViewHierarchy;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setGenerating(generating: boolean): void {
    try {
      if (!generating)
        this.generatingScope=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cancelForm(): void {
    try {
      if (this.isBusy)
        return;

      this.menuCancelled.emit();
      this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Statement versions

  public hasVersionHistory(scope: StatementScope): boolean {
    try {
      return this.versionsForScope(scope).length>1;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public isSelectedVersion(scope: StatementScope, statement: CompanyStatementDTO): boolean {
    try {
      const selected=this.selectedVersions.get(scope);

      if (selected==undefined || selected=="")
        return statement?.isLatest==true;

      return selected==statement?.idEnc;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public selectedVersionFor(scope: StatementScope): CompanyStatementDTO | undefined {
    try {
      const versions=this.versionsForScope(scope);
      const selected=this.selectedVersions.get(scope);

      if (selected==undefined || selected=="")
        return versions.find(v => v.isLatest) ?? versions[0];

      return versions.find(v => v.idEnc==selected);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setVersions(scope: StatementScope, versions: CompanyStatementDTO[]): void {
    try {
      this.versionsByScope.set(scope, versions ?? []);
      this.selectedVersions.delete(scope);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public versionLabel(statement: CompanyStatementDTO): string {
    try {
      if (statement==undefined)
        return "";

      const versionPart=" Version " + (statement.versionNo ?? 0);
      const statusPart =statement.isLatest ? " (current)" : " (superseded)";

      return versionPart + statusPart;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public versionOnClick(scope: StatementScope, statement: CompanyStatementDTO): void {
    try {
      if (this.isBusy || statement==undefined)
        return;

      this.selectedVersions.set(scope, statement.idEnc ?? "");

      this.versionSelected.emit({ scope           : scope,
                                  statementIdEncSS: statement.isLatest ? undefined : statement.idEnc,
                                  versionNo       : statement.versionNo });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public versionsForScope(scope: StatementScope): CompanyStatementDTO[] {
    try {
      return this.versionsByScope.get(scope) ?? [];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  //#endregion

  public canUseScope(scope: StatementScope): boolean {
    try {
      return this.canViewScope(scope) || this.canGenerate;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public canDownloadScope(scope: StatementScope): boolean {
    try {
      return this.canViewScope(scope);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public canViewScope(scope: StatementScope): boolean {
    try {
      return scope==StatementScope.Hierarchy ? this.canViewHierarchy : this.canViewCompanyOnly;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public canRegenerateScope(scope: StatementScope): boolean {
    try {
      return this.canGenerate && this.canViewScope(scope);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public downloadCsvOnClick(scope: StatementScope): void {
    try {
      if (!this.canDownloadScope(scope) || this.isBusy)
        return;

      this.downloadCsvSelected.emit(scope);

      if (!this.keepMenuOpen)
        this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public downloadPdfOnClick(scope: StatementScope): void {
    try {
      if (!this.canDownloadScope(scope) || this.isBusy)
        return;

      this.downloadPdfSelected.emit(scope);

      if (!this.keepMenuOpen)
        this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public regenerateOnClick(scope: StatementScope): void {
    try {
      if (!this.canRegenerateScope(scope) || this.isBusy)
        return;

      this.generatingScope=scope;
      this.generateSelected.emit(scope);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get isBusy(): boolean {
    try {
      return this.generatingScope!=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public isGeneratingScope(scope: StatementScope): boolean {
    try {
      return this.generatingScope==scope;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public viewOnClick(scope: StatementScope): void {
    try {
      if (!this.canUseScope(scope) || this.isBusy)
        return;

      if (this.canViewScope(scope)) {
        this.viewSelected.emit(scope);

        if (!this.keepMenuOpen)
          this.closeForm();

        return;
      }

      this.generatingScope=scope;
      this.generateAndViewSelected.emit(scope);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
